import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class Utils {

    constructor() { }

    endsWith(value: any, sub_str: any) {
        return value.length >= sub_str.length && value.substr(value.length - sub_str.length) == sub_str;
    }
}